// extracted by mini-css-extract-plugin
export default {"PersonIllustration":"Error_PersonIllustration__6STXU","Error":"Error_Error__ugfNm","Legal":"Error_Legal__ATrc+","TermsOfUse":"Error_TermsOfUse__rzPQf"};